var constants = require('./constants');

const STATSIG_GOALS = {
    CART: { name: 'ecomm_cart', value: null },
    INTENT_PROCEED: { name: 'ecomm_step_continue_cta', value: 'cart' },
    CHECKOUT_LOGIN: { name: 'account_registration_login', value: null },
    CHECKOUT_DELIVERY: { name: 'ecomm_checkout', value: null },
    CHECKOUT_PAYMENT: { name: 'ecomm_payment', value: null },
    CHECKOUT_CONFIRMATION: { name: 'ecomm_completed', value: null },
    SIGNUP: { name: 'sign_up', value: null }
};

function getStatsigClient() {
    if (!window.Statsig) {
        return null;
    }

    if (window.nmStatsigClient) {
        return window.nmStatsigClient;
    }

    const apiKey = window.nmStatsigApiKey || $('#statsig-data').data('key');
    if (!apiKey) {
        return null;
    }

    return window.Statsig.StatsigClient.instance(apiKey);
}

function logStatsigEvent(id) {
    if (!window.Statsig) {
        return;
    }

    if (!STATSIG_GOALS[id]) {
        return;
    }

    const event = STATSIG_GOALS[id];
    const statsigInstance = getStatsigClient();
    if (!statsigInstance) {
        return;
    }

    statsigInstance.logEvent(event.name, event.value);
}

function oosStylePLP() {
    const $unavailableTiles = $('.product-tile:not(.tile-can-hover)');
    $unavailableTiles.find('.tile-body-container, .image-container img').addClass('is-unavailable');

}

function subscribeAndSaveHeaderBanner() {
    const statsigInstance = getStatsigClient();
    if (statsigInstance) {
        const experiment = statsigInstance.getExperiment('ecom_10_percent_visibility');
        const isNewHeaderBanner = experiment.get('newHeaderBanner');

        if (isNewHeaderBanner) {
            const date = new Date();
            date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000); // 1 month
            document.cookie = 'plpSSBanner=true; path=/; expires=' + date.toUTCString() + ';';

            $('.ss-header-banner-container').removeClass('d-none');

            const isFirstPage = $('.grid-footer').data('page-number') === 0;
            if (isFirstPage) {
                $('.ss-tile').removeClass('d-none');
            }
        } else {
            document.cookie = 'plpSSBanner=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
            $('.header-banner-container').removeClass('d-none');
        }
    }
}

module.exports = {
    handleEvent: function (event) {
        const stepGoalMap = {
            cart: 'CART',
            intentToProceed: 'DUALMODE_INTENT_PROCEED',
            signup: 'SIGNUP',
            0: 'CHECKOUT_LOGIN',
            1: 'CHECKOUT_DELIVERY',
            2: 'CHECKOUT_PAYMENT',
            4: 'CHECKOUT_CONFIRMATION',
        };

        const goal = stepGoalMap[event];
        if (goal) {
            logStatsigEvent(goal);
        }
    },
    updateStatsigUser: function (data) {
        // Update the user object
        if (window.Statsig && data && data.statsigUserID) {
            const statsigInstance = getStatsigClient();
            if (!statsigInstance) {
                return;
            }
            const { user } = statsigInstance.getContext();
            const newUser = { ...user, userID: data.statsigUserID };
            statsigInstance.updateUserSync(newUser);

            const date = new Date();
            date.setTime(date.getTime() + constants.DAYS_30); // 1 month
            document.cookie = 'statsig_user=' + JSON.stringify(newUser) + '; path=/; ' + cookieDomain + 'expires=' + date.toUTCString() + '; Secure; SameSite=None;';
        }
    },
    handleExperiments: function () {
        subscribeAndSaveHeaderBanner();
        oosStylePLP();
    }
};
